import styled from "@emotion/styled";
import { Maximize2 } from "react-feather";
import { StyledPropsWithTheme } from "../../utils/globalTypes";

const MaximizeLogo = styled(Maximize2)<StyledPropsWithTheme>`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Styled = { MaximizeLogo };
